import React from 'react';
import './skleton.css'
const skleletonElement=({type})=>{
    const classes=`skleton ${type}`;
    return(
        <div className={classes}></div>
    )
}

export default skleletonElement;